import messages from '@/modules/assessments/components/messages.ts'

export const assessmentChildTabs = (hasConsultationReason?: boolean) => [
  {
    path: '',
    async lazy() {
      const { BasicAssessment } = await import(
        '@/modules/assessments/components/BasicAssessment'
      )
      return {
        Component: BasicAssessment,
      }
    },
    handle: {
      title: messages.basicAssessment,
    },
  },
  {
    path: 'needs',
    handle: {
      title: messages.needs,
    },
    async lazy() {
      const { AssessmentDetails } = await import(
        '@/modules/assessments/components/AssessmentDetails'
      )
      return {
        Component: AssessmentDetails,
      }
    },
    children: [
      {
        path: '',
        async lazy() {
          const { BasicInfo } = await import(
            '@/modules/assessments/components/AssessmentDetails/BasicInfo/index'
          )
          return {
            Component: BasicInfo,
          }
        },
      },
      {
        path: 'organization',
        async lazy() {
          const { OrganizationDetails } = await import(
            '@/modules/assessments/components/AssessmentDetails/OrganizationDetails/index'
          )
          return {
            Component: OrganizationDetails,
          }
        },
      },
      {
        path: 'mobility',
        async lazy() {
          const { MobilityDetails } = await import(
            '@/modules/assessments/components/AssessmentDetails/MobilityDetails/index'
          )
          return {
            Component: MobilityDetails,
          }
        },
      },
      {
        path: 'mental-health',
        async lazy() {
          const { MentalHealth } = await import(
            '@/modules/assessments/components/AssessmentDetails/MentalHealth/index'
          )
          return {
            Component: MentalHealth,
          }
        },
      },
      {
        path: 'physical-health',
        async lazy() {
          const { PhysicalHealth } = await import(
            '@/modules/assessments/components/AssessmentDetails/PhysicalHealth/index'
          )
          return {
            Component: PhysicalHealth,
          }
        },
      },
      {
        path: 'self-sufficiency',
        async lazy() {
          const { SelfSufficiency } = await import(
            '@/modules/assessments/components/AssessmentDetails/SelfSufficiency/index'
          )
          return {
            Component: SelfSufficiency,
          }
        },
      },
      {
        path: 'social-contact',
        async lazy() {
          const { SocialContact } = await import(
            '@/modules/assessments/components/AssessmentDetails/SocialContact/index'
          )
          return {
            Component: SocialContact,
          }
        },
      },
      {
        path: 'living-environment',
        async lazy() {
          const { LivingEnvironment } = await import(
            '@/modules/assessments/components/AssessmentDetails/LivingEnvironment/index'
          )
          return {
            Component: LivingEnvironment,
          }
        },
      },
      {
        path: 'care-relationship',
        async lazy() {
          const { CareRelationship } = await import(
            '@/modules/assessments/components/AssessmentDetails/CareRelationship/index'
          )
          return {
            Component: CareRelationship,
          }
        },
      },
      {
        path: 'relatives-view',
        async lazy() {
          const { RelativesView } = await import(
            '@/modules/assessments/components/AssessmentDetails/RelativesView/index'
          )
          return {
            Component: RelativesView,
          }
        },
      },
    ],
  },
  {
    path: 'additional-information',
    handle: {
      title: messages.additionalInformation,
    },
    async lazy() {
      const { AssessmentAdditionalInfo } = await import(
        '@/modules/assessments/components/AssessmentAdditionalInfo'
      )
      return {
        Component: AssessmentAdditionalInfo,
      }
    },
  },
  {
    path: 'overview',
    handle: {
      title: messages.overview,
    },
    async lazy() {
      const { Overview } = await import(
        '@/modules/assessments/components/Overview'
      )
      return {
        Component: Overview,
      }
    },
  },
  {
    path: 'protocol',
    async lazy() {
      const { Protocol } = await import(
        '@/modules/assessments/components/Protocol'
      )
      return {
        Component: Protocol,
      }
    },
    handle: {
      title: messages.protocol,
    },
    disabled: !hasConsultationReason,
  },
  {
    path: 'summary',
    handle: {
      title: messages.summary,
    },
    async lazy() {
      const { Summary } = await import(
        '@/modules/assessments/components/Summary'
      )
      return {
        Component: Summary,
      }
    },
  },
]

export const assessmentChildRoutes = assessmentChildTabs()
